export async function copyToClipboard(text: string): Promise<boolean> {
    try {
        if (navigator.clipboard && typeof navigator.clipboard.writeText === "function") {
            await navigator.clipboard.writeText(text);
            return true;
        }
    } catch {
        // ignore and fall back
    }
    try {
        const ta = document.createElement("textarea");
        ta.value = text;
        ta.setAttribute("readonly", "");
        ta.style.position = "fixed";
        ta.style.left = "-9999px";
        document.body.appendChild(ta);
        ta.select();
        // iOS support
        try {
            ta.setSelectionRange(0, ta.value.length);
        } catch {
            // ignore if not supported
        }
        const ok = document.execCommand("copy");
        document.body.removeChild(ta);
        return Boolean(ok);
    } catch {
        return false;
    }
}